import type { EventStore } from "@ancestors/models";
import { createContext, use } from "react";
import invariant from "tiny-invariant";

export interface EventStoreContextValue {
  eventStore: EventStore;
  setEventId: (eventId: string | null) => void;
}

export const EventStoreContext = createContext<EventStoreContextValue | null>(null);

export function useEventStore() {
  const context = use(EventStoreContext);
  invariant(context, "`useEventStore` must be used within a `EventStoreProvider`");
  return context;
}
